module.exports = {"421127100":"黄梅镇","421127101":"孔垄镇","421127102":"小池镇","421127103":"下新镇","421127104":"大河镇","421127105":"停前镇","421127106":"五祖镇","421127107":"濯港镇","421127108":"蔡山镇","421127109":"新开镇","421127110":"独山镇","421127111":"分路镇","421127200":"柳林乡","421127201":"杉木乡","421127202":"苦竹乡","421127203":"刘佐乡","421127400":"五祖寺（挪步园）风景名胜区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421127.json
// module id = 1779
// module chunks = 0